import styled from 'styled-components';
import React, { Suspense, useContext } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import Routes from '../../routes';
import withShowModalFlag from '../../composers/queries/withShowModalFlag';
import { atLaptopLarger } from '../../utils/mediaQuery';
import { ConfigContext } from '../ConfigContextProvider';
import Layout from '../../layouts/HeaderFooterLayout';
import url from '../../utils/url';

const Section = styled.section`
  height: inherit;
  min-height: 100vh;

  ${({ blur }) =>
    blur &&
    `
    overflow: hidden;
    filter: blur(8px);
  `}

  ${({ isAppOnly }) => !isAppOnly && `
    min-height: unset;
  `}

  ${atLaptopLarger(`
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 86px);

    @media only screen and (max-height: 767px) {
      min-height: 100vh;
    }
  `)}
`;

const Header = loadable(() =>
  import(
    /* webpackChunkName: "Header" */
    '../../components/Header'
  )
);

const Footer = loadable(() =>
  import(
    /* webpackChunkName: "Footer" */
    '../../components/Footer'
  )
);

const Scaffold = ({ showModal }) => {
  const { isMobileLayout } = useContext(ConfigContext);
  const isAppOnly = url.isAppOnly();

  const mobileLayout = (
    <Section blur={showModal} isAppOnly={isAppOnly}>
      <Suspense fallback={<div />}>
        <Route
          exact
          path="/:region/configurator/:year/:model/:section"
          component={Header}
        />
      </Suspense>
      <Routes />
      <Suspense fallback={<div />}>
        <Route
          exact
          path="/:region/configurator/:year/:model/:section"
          component={Footer}
        />
      </Suspense>
    </Section>
  );

  return (
    <>
      {isMobileLayout && isAppOnly && mobileLayout}
      {isMobileLayout && !isAppOnly && <Layout isMobileLayout>{mobileLayout}</Layout>}
      {!isMobileLayout && (
        <Layout>
          <Section blur={showModal}>
            <Routes />
          </Section>
        </Layout>
      )}
    </>
  );
};

Scaffold.propTypes = {
  showModal: PropTypes.bool
};

Scaffold.defaultProps = {
  showModal: false
};

export default withShowModalFlag(Scaffold);
